import { CascadiaColorTypes } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { RequirementsItem as RequirementItemType } from "./types";
import { Icon } from "../../foundations/icons/Icon/Icon";
import { Text } from "../../foundations/typography/Text";
import { useColors } from "../../hooks/useColors";
export interface RequirementItemProps {
  requirementsItem: RequirementItemType;
  testID?: string;
}

export function RequirementsItem({
  requirementsItem,
  testID = "requirements-item",
}: RequirementItemProps) {
  const colors = useColors();
  const requirementsItemIcon = {
    normal: <Icon name="bullet" type="custom" color="icon-base" />,
    success: (
      <Icon name="check" type="mini" color="icon-success" padding="space-05" />
    ),
    error: (
      <Icon name="error" type="mini" color="icon-danger" padding="space-05" />
    ),
  };
  const styles = getStyles(colors);

  return (
    <li className={css(styles.requirementsItemWrapper)} data-testid={testID}>
      {requirementsItemIcon[requirementsItem.style]}
      <Text
        className={css(styles.textStyles[requirementsItem.style])}
        style="form/body-secondary"
        color="text-weak"
      >
        {requirementsItem.text}
        {requirementsItem.recommended &&
          ` (${requirementsItem.recommendedText})`}
      </Text>
    </li>
  );
}

const getStyles = (colors: CascadiaColorTypes) => {
  return {
    textStyles: {
      normal: css({
        color: "var(--text-weak)",
        marginLeft: "var(--space-1)",
      }),
      error: css({
        color: "var(--text-danger)",
        marginLeft: "var(--space-1)",
      }),
      success: css({
        color: "var(--text-success)",
        marginLeft: "var(--space-1)",
      }),
    },
    requirementsItemWrapper: css({
      display: "flex",
      alignContent: "center",
      marginTop: "var(--space-05)",
      marginBottom: "var(--space-05)",
    }),
  };
};
